import React from "react";
import { useSharedTranslation } from "@/shared/contexts/TranslateContext";

import IconView from "@/shared/components/IconView/IconView";
import EgwWebFont from "@/shared/assets/EgwWebFont";
import { YOUTUBE_CHANNEL_URL } from "@/shared/utils/external/youtube/constants";
import { addQuotes } from "@/shared/utils/string/string";

export const LinkLearnHowToUseApps = ({
  link = YOUTUBE_CHANNEL_URL, title = "egwWritingsApps", style
}) => {
  const { t } = useSharedTranslation();

  return (
    <span style={style}>
      <IconView style={{
        color: "red",
      }} icon={EgwWebFont.youtube}/>
      &nbsp;
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={link}
        style={{
          fontFamily: "Roboto",
          letterSpacing: "0.01em",
        }}
      >
        {t("learnHowToUse") + " " + addQuotes(t(title))}
      </a>
    </span>
  );
};